import { render, staticRenderFns } from "./checkUpStatus.vue?vue&type=template&id=89f0fe14"
import script from "./checkUpStatus.vue?vue&type=script&lang=js"
export * from "./checkUpStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89f0fe14')) {
      api.createRecord('89f0fe14', component.options)
    } else {
      api.reload('89f0fe14', component.options)
    }
    module.hot.accept("./checkUpStatus.vue?vue&type=template&id=89f0fe14", function () {
      api.rerender('89f0fe14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkUpStatus.vue"
export default component.exports